import { v4 } from 'uuid';

import { UploadedFile } from '../useUserUpload/use-user-upload.types';

export const allowedTypes = ['application/pdf', 'image/png', 'image/jpeg'];

export const formatUploadFiles = (files: File[]): UploadedFile[] => {
  const selectedFiles = Array.from(files);

  return selectedFiles.map(i => {
    const thumbnailUrl = i.type.startsWith('image/')
      ? URL.createObjectURL(i)
      : undefined;

    return {
      field_name: v4(),
      fileType: i.type,
      status: 'uploading',
      fileData: i,
      name: i.name,
      sizeInBytes: i.size,
      thumbnailUrl,
    };
  });
};
